import React from 'react';
import styled from '@emotion/styled';
import KvSImg01 from 'ui/images/top_for_agent/kv_simg01@2x.png';
import KvSImgSp03 from 'ui/images/top_for_agent/kv_simg03@2x.png';
import KvSImgPc03 from 'ui/images/top_for_agent/kv_simg03@2x.png';
import KvImg01 from 'ui/images/top_for_agent/kv_img01@2x.png';
import KvImg02 from 'ui/images/top_for_agent/kv_img02@2x.png';
import KvSImgSp02 from 'ui/images/top_for_agent/kv_simg02@2x.png';
import { mqMin } from 'utils/responsive';

const KvIllust = styled.div`
    ${mqMin('NARROW')} {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 1440px;
        height: 700px;
    }
`;

const ImgContainerS01 = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        top: 265px;
        left: 87px;
        width: 164px;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
    }
`;

const ImgContainerS03Sp = styled.div`
    display: block;
    position: absolute;
    top: 15.53719008264463%;
    right: -15%;
    width: 34.18604651162791%; /*147px*/
    max-width: 200px;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;

    ${mqMin('SP')} {
        right: 5%;
    }

    ${mqMin('NARROW')} {
        display: none;
    }
`;

const ImgContainerS03Pc = styled.div`
    display: none;

    ${mqMin('NARROW')} {
        display: block;
        position: absolute;
        top: 490px;
        right: 78px;
        width: 188px;
        max-width: initial;
        opacity: 0;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.5s forwards;
    }
`;

const ImgContainer01 = styled.div`
    position: absolute;
    bottom: -130px;
    left: -200px;
    width: 34.88372093023256%; /* 150px */
    max-width: 170px;
    height: auto;
    animation: kvLeft 0.6s cubic-bezier(0.33, 1, 0.68, 1) 0.6s forwards;

    ${mqMin('NARROW')} {
        width: 220px;
        max-width: initial;
        bottom: 0;
        left: 350px;
        opacity: 0;
        animation: kvLeft 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1.2s forwards;
    }
`;

const ImgContainer02 = styled.div`
    position: absolute;
    bottom: -130px;
    right: -200px;
    width: 34.88372093023256%; /* 150px */
    max-width: 170px;
    height: auto;
    animation: kvRight 0.6s cubic-bezier(0.33, 1, 0.68, 1) 0.6s forwards;

    ${mqMin('NARROW')} {
        width: 220px;
        max-width: initial;
        bottom: 0;
        right: 350px;
        opacity: 0;
        animation: kvRight 1.2s cubic-bezier(0.33, 1, 0.68, 1) 1.2s forwards;
    }
`;

const ImgContainerS02Sp = styled.div`
    position: absolute;
    top: 0px;
    left: -10px;
    width: 28.6046511627907%; /*123px*/
    max-width: 170px;
    opacity: 0;
    animation: kvFadeinZoom 0.4s cubic-bezier(0.33, 1, 0.68, 1) 0.4s forwards;

    ${mqMin('SP')} {
        left: 10%;
    }

    ${mqMin('NARROW')} {
        top: 489px;
        left: 95px;
        width: 168px;
        max-width: initial;
        animation: kvFadeinZoom 0.5s cubic-bezier(0.33, 1, 0.68, 1) 0.8s forwards;
    }
`;

export const KvPictures: React.FC = () => {
    return (
        <KvIllust>
            <ImgContainerS01>
                <img src={KvSImg01} alt="" />
            </ImgContainerS01>
            <ImgContainerS03Sp>
                <img src={KvSImgSp03} alt="" />
            </ImgContainerS03Sp>
            <ImgContainerS03Pc>
                <img src={KvSImgPc03} alt="" />
            </ImgContainerS03Pc>
            <ImgContainer01>
                <img src={KvImg01} alt="" />
            </ImgContainer01>
            <ImgContainer02>
                <img src={KvImg02} alt="" />
            </ImgContainer02>
            <ImgContainerS02Sp>
                <img src={KvSImgSp02} alt="" />
            </ImgContainerS02Sp>
        </KvIllust>
    );
};
